import { createHttpParams } from '$core/helpers/http-params';
import { Pagination, PaginationSingleData } from '$core/models/pagination';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddressBook } from './address-book';
import { OldAddressBook } from './old-address-book';

@Injectable({
  providedIn: 'root',
})
export class AddressBookService {
  private apiRoute = '/postcodes';
  protected apiVersion = '/v1';

  public get apiRouteWithVersion(): string {
    return this.apiVersion + this.apiRoute;
  }

  constructor(private http: HttpClient) {}

  public getAutocomplete(params: Params, url?: string) {
    return this.http
      .get<AddressBook.Result[]>(
        `${this.apiVersion}${url ? '/' + url : this.apiRoute}/autocomplete`,
        {
          params: createHttpParams(params),
        }
      )
      .pipe(map((res) => res.map((r) => new AddressBook.Result(r))));
  }

  public getElasticResult(
    params: Params
  ): Observable<PaginationSingleData<AddressBook.ElasticSearchResult>> {
    return this.http
      .get<PaginationSingleData<AddressBook.ElasticSearchResult>>(
        `${this.apiRouteWithVersion}/search`,
        {
          params: createHttpParams({
            ...params,
            page: params.page || 1, // this is for reinsurance, otherwise return type will be different
          }),
        }
      )
      .pipe(
        map((res) => ({
          ...res,
          data: new AddressBook.ElasticSearchResult(res.data),
        }))
      );
  }

  public getCities(query: string, page?: number) {
    const params = new HttpParams()
      .set('city', query || '')
      .set('page', page ? page.toString() : '1');

    return this.http
      .get<Pagination<OldAddressBook.ComplexCity>>(
        `${this.apiRouteWithVersion}/cities`,
        {
          params,
        }
      )
      .pipe(
        map((items) => {
          return {
            ...items,
            data: items.data.map(
              (item) => new OldAddressBook.ComplexCity(item)
            ),
          };
        })
      );
  }

  public getStreets(
    region: string,
    district: string,
    city: string,
    street?: string,
    page?: number
  ) {
    const params = new HttpParams()
      .set('region', region || '')
      .set('district', district || '')
      .set('city', city || '')
      .set('street', street || '')
      .set('page', page ? page.toString() : '1');

    return this.http
      .get<Pagination<any>>(`${this.apiRouteWithVersion}`, {
        params,
      })
      .pipe(
        map((items) => {
          return {
            ...items,
            data: items.data.map(
              (item) => new OldAddressBook.ComplexStreet(item)
            ),

            // для логики чтобы не повторялись одинаковые улицы по несколько раз,
            // но одинаковое название переулка и улицы считает как одинаковую позицию и не отображает
            // например: улица Карского и переулок Карского отобразит либо только улицу либо только переулок

            // data: this.uniquePipe
            // .transform(items.data, 'street')
            // .filter(item => Boolean(item.street_type))
            // .map(item => new OldAddressBook.ComplexStreet(item)),
          } as Pagination<OldAddressBook.ComplexStreet>;
        })
      );
  }

  public getResult(params: Params) {
    return this.http.get<
      | PaginationSingleData<AddressBook.ElasticSearchResult>
      | AddressBook.ElasticSearchResult
    >(`${this.apiRouteWithVersion}`, {
      params: createHttpParams({
        ...params,
        page: params.page || 1,
      }),
    });
  }
}
